/**
 * Mobile Line Switcher - Controls line visibility on mobile devices
 * Shows only one line at a time on md and smaller screens
 * Saves user preference to localStorage
 */

// Default to Line 1 University branch
let currentMobileLine = 'line1';
let currentMobileBranch = 'university';

/**
 * Initialize mobile line switcher
 */
function initializeMobileLineSwitcher() {
    // Load saved preferences from localStorage
    loadMobileLinePreferences();
    
    // Apply initial visibility
    updateMobileLineVisibility();
    
    // Update button states
    updateMobileButtonStates();
    
    // Set up media query listener to handle screen size changes
    const mediaQuery = window.matchMedia('(max-width: 1023px)');
    mediaQuery.addListener(handleScreenSizeChange);
    handleScreenSizeChange(mediaQuery);
}

/**
 * Load preferences from localStorage
 */
function loadMobileLinePreferences() {
    const savedLine = localStorage.getItem('ttc-mobile-line');
    const savedBranch = localStorage.getItem('ttc-mobile-branch');
    
    if (savedLine && ['line1', 'line2', 'line4', 'line5', 'line6'].includes(savedLine)) {
        currentMobileLine = savedLine;
    }
    
    if (savedBranch && ['university', 'yonge'].includes(savedBranch)) {
        currentMobileBranch = savedBranch;
    }
}

/**
 * Save preferences to localStorage
 */
function saveMobileLinePreferences() {
    localStorage.setItem('ttc-mobile-line', currentMobileLine);
    localStorage.setItem('ttc-mobile-branch', currentMobileBranch);
}

/**
 * Switch to a different line on mobile
 */
function switchMobileLine(line) {
    if (!['line1', 'line2', 'line4', 'line5', 'line6'].includes(line)) {
        console.error('Invalid line:', line);
        return;
    }
    
    currentMobileLine = line;
    
    // If switching to Line 1, default to university branch
    if (line === 'line1') {
        currentMobileBranch = 'university';
    }
    
    // Save preferences
    saveMobileLinePreferences();
    
    // Update visibility and button states
    updateMobileLineVisibility();
    updateMobileButtonStates();
}

/**
 * Switch to a different Line 1 branch on mobile
 */
function switchMobileBranch(branch) {
    if (!['university', 'yonge'].includes(branch)) {
        console.error('Invalid branch:', branch);
        return;
    }
    
    currentMobileBranch = branch;
    
    // Save preferences
    saveMobileLinePreferences();
    
    // Update visibility and button states
    updateMobileLineVisibility();
    updateMobileButtonStates();
}

/**
 * Update line visibility based on current selection
 */
function updateMobileLineVisibility() {
    const isSmallScreen = window.matchMedia('(max-width: 1023px)').matches;
    
    if (!isSmallScreen) {
        // On large screens, show all lines
        const allSvgs = document.querySelectorAll('#mapContainer svg');
        allSvgs.forEach(svg => {
            svg.classList.remove('mobile-visible');
            svg.style.display = '';
        });
        return;
    }
    
    // On small screens, hide all SVGs first
    const allSvgs = document.querySelectorAll('#mapContainer svg');
    allSvgs.forEach(svg => {
        svg.classList.remove('mobile-visible');
    });
    
    // Show the selected line/branch
    let targetSvgId = '';
    
    if (currentMobileLine === 'line1') {
        targetSvgId = `line1-${currentMobileBranch}-svg`;
    } else if (currentMobileLine === 'line5') {
        targetSvgId = 'line5-eglinton-svg';
    } else if (currentMobileLine === 'line6') {
        targetSvgId = 'line6-finchwest-svg';
    } else {
        targetSvgId = `${currentMobileLine}-svg`;
    }
    
    const targetSvg = document.getElementById(targetSvgId);
    if (targetSvg) {
        targetSvg.classList.add('mobile-visible');
    } else {
        console.warn('Target SVG not found:', targetSvgId);
    }
}

/**
 * Update button states to reflect current selection
 */
function updateMobileButtonStates() {
    // Update line buttons
    const lineButtons = document.querySelectorAll('.mobile-line-btn');
    lineButtons.forEach(btn => {
        const line = btn.getAttribute('data-line');
        if (line === currentMobileLine) {
            btn.classList.add('active');
        } else {
            btn.classList.remove('active');
        }
    });
    
    // Update branch buttons
    const branchButtons = document.querySelectorAll('.mobile-branch-btn');
    branchButtons.forEach(btn => {
        const branch = btn.getAttribute('data-branch');
        if (branch === currentMobileBranch) {
            btn.classList.add('active');
        } else {
            btn.classList.remove('active');
        }
    });
    
    // Show/hide branch switcher based on current line
    const branchSwitcher = document.getElementById('mobileBranchSwitcher');
    if (branchSwitcher) {
        if (currentMobileLine === 'line1') {
            branchSwitcher.style.display = 'flex';
        } else {
            branchSwitcher.style.display = 'none';
        }
    }
}

/**
 * Handle screen size changes
 */
function handleScreenSizeChange(mediaQuery) {
    updateMobileLineVisibility();
    
    // Update button visibility based on screen size
    const lineSwitcher = document.getElementById('mobileLineSwitcher');
    const branchSwitcher = document.getElementById('mobileBranchSwitcher');
    
    if (mediaQuery.matches) {
        // Small screen - show mobile controls
        if (lineSwitcher) lineSwitcher.style.display = 'flex';
        if (branchSwitcher && currentMobileLine === 'line1') {
            branchSwitcher.style.display = 'flex';
        }
    } else {
        // Large screen - hide mobile controls
        if (lineSwitcher) lineSwitcher.style.display = 'none';
        if (branchSwitcher) branchSwitcher.style.display = 'none';
    }
}

/**
 * Get current mobile line selection
 */
function getCurrentMobileLine() {
    return currentMobileLine;
}

/**
 * Get current mobile branch selection
 */
function getCurrentMobileBranch() {
    return currentMobileBranch;
}

// Make functions available globally for onclick handlers
window.switchMobileLine = switchMobileLine;
window.switchMobileBranch = switchMobileBranch;
window.updateMobileLineVisibility = updateMobileLineVisibility;

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeMobileLineSwitcher);

// Export functions for use in other modules
export {
    initializeMobileLineSwitcher,
    switchMobileLine,
    switchMobileBranch,
    updateMobileLineVisibility,
    getCurrentMobileLine,
    getCurrentMobileBranch
};